<template>
  <div class="card">
    <div class="top">
      <div class="t_left">
        <span>{{ lang.analysisAssistant }}</span>
      </div>
      <div class="t_right"></div>
    </div>
    <div class="main">
      <div class="m_messageArea" ref="messageAreaRef">
        <div class="m_ma_item" v-for="(item,index) in messageList" :key="item.uid">
          <div class="m_ma_item_box left" v-if="item.userContent">
            <div class="m_ma_i_message">
              <span>{{ item.userName }}</span>
              <div class="m_ma_i_m_messageBox" v-html="item.userContent"></div>
             
            </div>
            <div class="m_ma_i_avatarArea">
              <img src="../../../../assets/img/teachingMode/user_avatar.png" />
            </div>
          </div>

          <div class="m_ma_item_box right">
            <div class="m_ma_i_avatarArea">
              <img src="https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/d29b9ff431894a49b3ec3cc20c15f071.png" />
            </div>
            <div class="m_ma_i_message">
              <span>{{ item.aiName }}</span>
              <div
                class="m_ma_i_m_messageBox"
                :style="{overflow:item.loading?'hidden':'auto'}"
                v-loading="item.loading"
                v-html="item.aiContent"
              ></div>
              <div class="m_ma_i_m_suggestedArray" v-if="index == messageList.length - 1 && suggestedArray.length>0" >
                <div @click="useSuggested(suggested)" v-for="(suggested,sIndex) in suggestedArray" :key="sIndex+'_'+index">
                  {{ suggested }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m_bottom">
        <div class="m_b_mainArea">
          <div v-show="sendType === 0" class="m_b_ma_top">
            <textarea
              v-model="sendValue"
              ref="textareaRef"
              :disabled="sendLoading"
              :placeholder="lang.srnr"
              @input="keyDownFn"
              @change="keyDownFn"
              @keydown.enter="handleEnter"
              @compositionstart="isComposing = true"
              @compositionend="isComposing = false"
            ></textarea>
          </div>
          <div v-show="sendType === 0" class="m_b_ma_bottom" @click="$refs.textareaRef.focus()">
            <div class="m_b_ma_b_left"></div>
            <div class="m_b_ma_b_right">
              <el-tooltip class="item" effect="dark" :content="lang.voiceInput" placement="top">
                <div @click.stop="sendType = 1">
                <img src="../../../../assets/img/teachingMode/voice_icon.png" />
              </div>
              </el-tooltip>
              
              <span></span>
              <div @click.stop="sendMessage" v-if="!sendLoading">
                <img src="../../../../assets/img/teachingMode/send_icon.png" />
              </div>
              <div v-else class="m_b_ma_b_r_stop" @click.stop="stopSend">
                <span></span>
              </div>
            </div>
          </div>
          <div class="m_b_ma_voice" v-show="sendType===1">
            <div class="m_b_ma_v_left" ><!--:class="{m_b_ma_v_active:!record_start}"-->
              <el-input v-model="text" ref="voiceInputRef" style="width: 100%;" disabled></el-input>
              <!--<div v-for="item in 31" :key="item"></div>-->
            </div>
            <div class="m_b_ma_v_center">
              {{timeText(sendVoiceTime)}}
            </div>
            <div class="m_b_ma_v_right">
              <el-tooltip class="item" v-if="!sendLoading && record_start" effect="dark" :content="lang.textInput" placement="top">
                <span @click.stop="sendType = 0" >T</span>
              </el-tooltip>

              <el-tooltip class="item" v-if="record_start && !sendLoading" effect="dark" :content="lang.startRecording" placement="top">
                <img  @click="startVoice()" src="../../../../assets/img/teachingMode/start_voice.png" />
              </el-tooltip>

              <el-tooltip class="item" v-if="!record_start && !sendLoading" effect="dark" :content="lang.endRecording" placement="top">
                <img @click="stopVoice()" src="../../../../assets/img/teachingMode/stop_voice.png" />
              </el-tooltip>
             
             
              
              <div v-if="sendLoading" class="m_b_ma_b_r_stop" @click.stop="stopSend">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { myMixin } from "@/common/mixin";
export default {
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    fileUrl: {
      type: String,
      default: "",
    },
    studentListId:{
      type:String,
      default:""
    },
  },
  mixins: [myMixin],
  data() {
    return {
      sendValue: "",
      sendType: 0, // 0文本   1语音
      messageList: [],
      sendLoading: false,
      curRequestController: null,
      isComposing: false,
      suggestedArray: [],
      studentList: [],
      statusList: [
        this.lang.unfinished,
        this.lang.completed,
        this.lang.pause,
        this.lang.stop,
      ],
      sendVoiceTime:0,
      voiceStatus:0,//未开始  1 在录音
      voiceTimer:null,
      text:'',
      record_start:true,
    };
  },
  computed:{
    timeText() {
      return (seconds) => {
        seconds = Number(seconds) || 0;
        const pad = n => String(n).padStart(2, '0');
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${pad(h)}:${pad(m)}:${pad(s)}`;
      }
    }
  },
  methods: {
    sendMessage() {
      if (!this.sendValue) {
        this.$message({
          message: this.lang.input_content,
          type: "warning",
        });
        return;
      }

      let _msg = `${this.sendValue}`;

      // let _historyMessage = [{ role: "user", content: _msg }];

      let _uid = new Date().getTime();

      this.messageList.push({
        aiContent: "",
        aiName: this.lang.ai_assistant,
        userName: this.user.userName,
        userContent: this.sendValue,
        uid: _uid,
        createTime: new Date().getTime(),
        loading: true,
      });

      // let params  ={
      //   model: "gpt-4o-2024-11-20",
      //   temperature: 0,
      //   max_tokens: 4096,
      //   top_p: 1,
      //   frequency_penalty: 0,
      //   presence_penalty: 0,
      //   messages: _historyMessage,
      //   uid: _uid,
      //   mind_map_question: "",
      //   stream: true
      // }

      let params = {
        prompt: _msg,
        messages: [],
        file: this.fileUrl ? [this.fileUrl] : [],
      };

      let _addText = "";
      const md = new MarkdownIt();
      this.curRequestController = new AbortController();
      this.getSuggested(true,this.sendValue)
      this.sendValue = "";
      this.sendLoading = true;
      fetchEventSource("https://gpt4.cocorobo.cn/csvaimessagestream", {
        //chat_post_stream  https://gpt4.cocorobo.cn/csvaimessagestream     https://gpt4.cocorobo.cn/chat_post_stream
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
        signal: this.curRequestController.signal,
        onmessage: (ev) => {
          let _data = JSON.parse(ev.data);
          let _text = _data.data;
          let status = _data.event;
          if (status == "on_chat_model_stream") {
            _addText += _text;
            this.messageList.find((i) => i.uid === _uid).aiContent =
              md.render(_addText);
            this.messageList.find((i) => i.uid === _uid).loading = false;
          } else if (status == "on_chain_end") {
            this.messageList.find((i) => i.uid === _uid).aiContent =
              md.render(_text);
            this.messageList.find((i) => i.uid === _uid).loading = false;
          }
          // if (ev.data === "") return;
          // let _data = ev.data;
          // if (_data === "[DONE]") return;
          // _addText += _data;
          // this.messageList.find(i => i.uid === _uid).aiContent = md.render(_addText);
          // this.messageList.find(i => i.uid === _uid).loading = false;
          this.scrollBottom();
        },
        onclose: () => {
          this.curRequestController = null;
          this.sendLoading = false;
          console.log("连接关闭");
        },
        onerror: (err) => {
          console.log("连接错误", err);
          this.sendLoading = false;
          this.stopSend();
        },
      });

    },
    // 停止消息
    stopSend() {
      if (this.curRequestController) {
        this.curRequestController.abort();
        console.log("请求已终止");
        this.sendLoading = false;
        this.sendValue = "";
        this.curRequestController = null;
      }
    },
    // 滚动条触底
    scrollBottom() {
      this.$refs.messageAreaRef.scrollTop =
        this.$refs.messageAreaRef.scrollHeight;
    },
    // 输入框监听输入
    keyDownFn() {
      // console.log(this.sendValue)
    },
    handleEnter(event) {
      if (this.isComposing) {
        // 中文输入法组词中，回车不上屏
        return;
      }
      this.sendMessage();
      event.preventDefault();
    },
    // 获取学生数据
    getStudentWorkData(sid) {
      return new Promise((resolve) => {
        if (!this.obj.id) return resolve([]);
        let params = {
          uid: this.user.userId,
          tid: this.obj.id,
          sid: sid,
        };

        this.ajax
          .get(this.$store.state.api + "select_teachingModeWorks", params)
          .then((res) => {
            let _result = res.data[0];
            if (_result.length > 0) {
              _result.forEach((i) => {
                //i.summary = i.summary ? JSON.parse(i.summary) : "";
                i.nodeData = i.nodeData ? JSON.parse(i.nodeData) : [];
              });

              resolve(_result);
            } else {
              resolve([]);
            }
          })
          .catch((err) => {
            console.log(err);
            resolve([]);
          });
      });
    },
    // 获取建议问题
    async getSuggested(flag = true,text = "") {
      console.log("获取建议",flag,this.studentList,this.studentListId)
      this.suggestedArray = [];
      if (this.studentList.length > 0) {
        let _msgText = ``;

        this.studentList.forEach((s) => {
          _msgText += `学生：${s.name}\n总结：${s.summary}\n总节点数量：${
            s.stage
          }\n任务状态：${this.statusList[s.status]}\nID：${s.id}\n`;
          s.nodeData.forEach((n, nIndex) => {
            _msgText += `【节点${(nIndex + 1).toString().padStart(2, "0")} ${
              n.messageList[0] ? n.messageList[0].aiName : "-"
            }】表情：${
              n.status == "0" ? "微笑" : n.status == "1" ? "不高兴" : "无表情"
            }\n`;
            n.messageList.forEach((m) => {
              _msgText += `${m.userName}(${m.chatTime})：\n${m.userContent}\n${m.aiName}：\n${m.aiContent}\n`;
            });
          });
          _msgText += "\n";
        });

        
        let _msg = `# 任务说明
你是一个智能教学分析助手，需要基于当前的学习数据分析结果，为教师生成3个最有价值的问题选项，帮助教师深入了解学生学习情况和获得针对性的教学指导。

你需要生成的问题应该：
1. 直接针对当前发现的关键教学问题和学生需求
2. 能够引导教师获得更深入的分析洞察  
3. 具有实际的教学指导价值和可操作性
4. 表达简洁明确，便于教师快速理解和选择

# 输入信息

## 用户提问
${text}

## 学习分析摘要
${_msgText}

# 输出格式

请严格按照以下格式输出3个问题，每个问题占一行：
["具体问题内容","具体问题内容","具体问题内容"]

# 问题生成策略

## 1. 问题类型框架

**深度分析类问题**
- 针对特定现象的深层原因分析
- 学生学习行为模式的解读
- 教学效果的影响因素探讨

**对策指导类问题**  
- 针对具体问题的解决方案建议
- 不同学生群体的差异化教学策略
- 课程改进和优化的具体方向

**预测判断类问题**
- 学习趋势的预测和判断
- 潜在风险的识别和预警
- 教学调整的效果预期

## 2. 问题焦点识别

**基于学习卡点生成问题**
如果发现特定节点卡点较多：
- "为什么有X名学生在[具体节点]遇到困难？"
- "如何帮助卡在[节点名称]的学生突破难点？"
- "是否需要调整[节点内容]的教学策略？"

**基于能力分层生成问题**
如果发现明显的能力差异：
- "如何为不同能力层次的学生设计差异化教学？"
- "优秀学生有什么共同特征可以推广？"
- "待提升学生需要什么针对性支持？"

**基于疑难问题生成问题**
如果发现高频共性问题：
- "如何解决[具体问题]这一普遍困难？"
- "为什么多数学生在[问题领域]出现困惑？"
- "应该如何调整教学来预防[常见错误]？"

**基于完成情况生成问题**
如果发现完成率异常：
- "完成率为X%，主要影响因素是什么？"
- "如何提高未完成学生的参与度？"
- "当前的学习进度是否合理？"

## 3. 问题表达原则

**简洁明确**：问题长度控制在15个字；避免复杂的从句和修饰语；使用教师熟悉的教育术语

**针对性强**：直接指向具体的数据发现；避免过于宽泛的一般性问题

**可操作性**：问题的回答能够指导具体的教学行动；聚焦于教师可以控制和改变的因素

**价值导向**：优先选择对教学改进最有帮助的问题；关注学生学习效果和体验

# 问题生成优先级

## 高优先级问题特征
- 涉及大比例学生的共同问题
- 影响核心学习目标达成的关键问题  
- 教师迫切需要指导的实际问题
- 有明确数据支撑的具体现象

## 中优先级问题特征
- 影响部分学生的特殊问题
- 教学过程优化的改进问题
- 学习效果提升的策略问题
- 预防性质的前瞻问题


# 问题生成示例

## 基于进度卡点的问题
输入：2名学生卡在节点3，主要是概念理解困难
输出：为什么有2名学生在概念理解阶段遇到困难？

## 基于能力差异的问题
输入：优秀组12人，待提升组仅4人
输出：如何让优秀学生的成功经验帮助待提升学生？

## 基于疑难问题的问题  
输入：自变量因变量理解困难出现5人次
输出：如何改进教学帮助学生理解自变量因变量概念？

请基于提供的学习分析摘要，运用上述策略生成3个最有价值的建议问题选项。`;

        let message = [{ role: "user", content: _msg }];
        this.chat_no_stream(message)
          .then((res) => {
            try {
              if (res) {
                let _group = JSON.parse(res);
                this.suggestedArray = _group;
              }
            } catch (error) {
              console.log("获取建议问题失败1");
              console.log(error);
            }
          })
          .catch((error) => {
            console.log("获取建议问题失败2");
            console.log(error);
          });
      } else if (this.studentListId && flag) {
        let _result = await this.getStudentWorkData(this.studentListId);
        this.changeStudentList(_result);
        this.getSuggested(false,text);
      }
    },
    // 更新学生数据
    changeStudentList(newValue) {
      this.studentList = JSON.parse(JSON.stringify(newValue));
    },
    // 使用建议
    useSuggested(suggested){
      this.sendValue = suggested;
      this.sendMessage();
    },
    // 开始语音
    startVoice(){
      if(!this.record_start || this.sendLoading)return;
        this.text = "";
      this.voiceTimer = setInterval(()=>{
        this.sendVoiceTime++;
      },1000)
      this.send_voice()

    },
    stopVoice(){
      if(this.record_start)return;
      this.stop_voice()
      console.log("text",this.text)
      clearInterval(this.voiceTimer);
      this.sendVoiceTime = 0;
      this.sendValue = this.text;
      this.sendMessage();
    },
    setFirstUseSuggested(){
      this.messageList.push({
        aiContent: this.lang.aiAssistantIntroduction,
        aiName: this.lang.ai_assistant,
        userName: this.user.userName,
        userContent: "",
        uid: '0',
        createTime: new Date().getTime(),
        loading: false,
      })
      this.getSuggested(true,"")
    },
  },
  watch:{
    studentListId(newVal){
      if(newVal){
        this.setFirstUseSuggested()
      }
    },
    text(newVal){
      if (newVal && this.$refs.voiceInputRef) {
        this.$nextTick(() => {
          const input = this.$refs.voiceInputRef.$el.querySelector('input');
          if (input) {
            // 通过设置 scrollLeft 保证最后的输入内容可见（滚动到最右侧）
            // input.focus();
            // input.setSelectionRange(input.value.length, input.value.length);
            input.scrollLeft = input.scrollWidth;
          }
        });
      }
    }
  },
  mounted(){
    // setInterval(()=>{
    //   this.text+='好好哄，'
    // },2000)
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  height: 100%;
  border: 1px solid rgba(245, 248, 255, 0.25);
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 16px 24px 2px rgba(0, 0, 0, 0.04);
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(16.700000762939453px);
  border-radius: 12px;
  box-sizing: border-box;
  gap: 20px;
  .top {
    width: 100%;
    height: 50px;
    background: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    .t_left {
      white-space: nowrap;
      & > span {
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        color: #000;
      }
    }
  }

  .main {
    width: 100%;
    height: calc(100% - 50px);
    background: #fafafa;

    .m_messageArea {
      width: 100%;
      height: calc(100vh - 120px - 80px - 100px - 50px - 92px);
      min-height: 500px;
      background: #fafafa;
      overflow: auto;
      box-sizing: border-box;
      padding: 20px 15px 20px 15px;
      .m_ma_item {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .m_ma_item_box {
          width: 100%;
          height: auto;
          display: flex;
          align-items: flex-start;
          .m_ma_i_avatarArea {
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 32px;
              height: 32px;
              border-radius:50%;
              object-fit: cover;
            }
          }
          .m_ma_i_message {
            height: auto;
            flex: 1;
            display: flex;
            flex-direction: column;
            margin: 0 5px;
            align-items: flex-start;
            & > span {
              font-size: 14px;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.9);
              margin-bottom: 5px;
            }
            .m_ma_i_m_messageBox {
              width: auto;
              height: auto;
              border-radius: 0 8px 8px 8px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(231, 231, 231, 1);
              box-sizing: border-box;
              padding: 12px;
              font-size: 16px;
              color: rgba(0, 0, 0, 0.9);
              font-weight: 400;
              line-height: 22px;
              min-width: 48px;
              min-height: 48px;
            }
            .m_ma_i_m_suggestedArray{
              width: 100%;
              height: auto;
              margin-top: 10px;
              display: flex;
              flex-direction: column;
              gap: 8px;
              &>div{
                width: fit-content;
                cursor: pointer;
                padding: 6px 12px;
                background: rgba(255, 255, 255, 0.9);
                border: 1px solid rgba(205, 224, 254, 1);
                border-radius: 4px;
                &:hover{
                  background: linear-gradient(180deg, #E7EEFE 0%, #FAFCFF 100%);
                }
              }

            }
          }
        }
        .left {
          justify-content: flex-end;
          .m_ma_i_message {
            align-items: flex-end !important;
            .m_ma_i_m_messageBox {
              background: rgba(0, 82, 217, 1);
              border-color: rgba(0, 82, 217, 1);
              border-radius: 8px 0px 8px 8px;
              color: #fff;
            }
          }
        }
        .right {
          justify-content: flex-start;
        }
      }
    }
    .m_bottom {
      width: 100%;
      height: 120px;
      background: rgba(245, 245, 245, 1);
      box-sizing: border-box;
      padding: 12px 15px;
      .m_b_mainArea {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 8px 12px;
        background: rgba(255, 255, 255, 1);
        border: 1.5px solid rgba(231, 231, 231, 1);
        border-radius: 4px;
        gap: 10px;
        display: flex;
        flex-direction: column;
        .m_b_ma_top {
          width: 100%;
          height: 50%;
          box-sizing: border-box;
          display: flex;
          align-items: flex-start;
          & > textarea {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            border: none;
            outline: none;
            resize: none;
            font-size: 14px;
            font-weight: 400;

            /* 修改 placeholder 的字体样式 */
            &::placeholder {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.26);
              font-weight: 400;
            }
          }
        }
        .m_b_ma_bottom {
          width: 100%;
          height: 50%;
          display: flex;
          justify-content: space-between;
          .m_b_ma_b_right {
            width: auto;
            height: 100%;
            display: flex;
            align-items: center;
            gap: 20px;
            & > div {
              cursor: pointer;
            }
            & > div:nth-of-type(1) {
              width: 24px;
              height: 24px;
            }
            & > div:nth-of-type(2) {
              max-width: 30px;
              max-height: 30px;
              min-width: 30px;
              min-height: 30px;
            }
            & > img {
              width: 100%;
              height: 100%;
            }
            & > span {
              width: 2px;
              height: 15px;
              background: #0052d9;
              border-radius: 1px;
            }
            .m_b_ma_b_r_stop {
              width: 30px;
              height: 30px;
              border-radius: 14px;
              background: rgb(200 198 198);
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              & > span {
                width: 12px;
                height: 12px;
                background: rgb(124 124 124);
              }
            }
          }
        }
        .m_b_ma_voice{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .m_b_ma_v_left{
            width: calc(100% - 65px - 100px - 20px);
            height: 40px;
            display: flex;
            gap: 5px;
            align-items: center;
            justify-content: space-around;
            &>div{
              width: 6px;
              height: 15px;
              background: #0052D9;
              border-radius: 8px;
            }
            ::v-deep(.el-input){
              height: 40px;
              background: none;
              input{
                outline: none;
                border: none;
                background: none;
                cursor: default;
                color: #000;
              }
            }
          }
          .m_b_ma_v_active {
            & > div {
              /* 定义动画起始高度与默认高度 */
              height: 15px;
              background: #0052D9;
              border-radius: 8px;
              width: 6px;
              animation: vu-meter-bar 3s infinite;
              /* 设置动画延迟，从中心开始往外递增 */
            }
            /* 31个div，从0到30 */
            /* vue循环是 v-for="item in 31"，第一个是1 */
            /* 中间是16 (index 15, 0-based) */
            & > div:nth-child(16) { animation-delay: 0s; }
            & > div:nth-child(15),
            & > div:nth-child(17) { animation-delay: 0.05s; }
            & > div:nth-child(14),
            & > div:nth-child(18) { animation-delay: 0.10s; }
            & > div:nth-child(13),
            & > div:nth-child(19) { animation-delay: 0.15s; }
            & > div:nth-child(12),
            & > div:nth-child(20) { animation-delay: 0.20s; }
            & > div:nth-child(11),
            & > div:nth-child(21) { animation-delay: 0.25s; }
            & > div:nth-child(10),
            & > div:nth-child(22) { animation-delay: 0.30s; }
            & > div:nth-child(9),
            & > div:nth-child(23) { animation-delay: 0.35s; }
            & > div:nth-child(8),
            & > div:nth-child(24) { animation-delay: 0.40s; }
            & > div:nth-child(7),
            & > div:nth-child(25) { animation-delay: 0.45s; }
            & > div:nth-child(6),
            & > div:nth-child(26) { animation-delay: 0.50s; }
            & > div:nth-child(5),
            & > div:nth-child(27) { animation-delay: 0.55s; }
            & > div:nth-child(4),
            & > div:nth-child(28) { animation-delay: 0.60s; }
            & > div:nth-child(3),
            & > div:nth-child(29) { animation-delay: 0.65s; }
            & > div:nth-child(2),
            & > div:nth-child(30) { animation-delay: 0.70s; }
            & > div:nth-child(1),
            & > div:nth-child(31) { animation-delay: 0.75s; }
          }

          @keyframes vu-meter-bar {
            0%,
            100% {
              height: 15px;
            }
            15% {
              height: 33px;
            }
            35% {
              height: 22px;
            }
            50% {
              height: 44px;
            }
            65% {
              height: 22px;
            }
            85% {
              height: 33px;
            }
          }
          .m_b_ma_v_center{
            width: 65px;
            height: auto;
          }
          .m_b_ma_v_right{
            width: 100px;
            height: auto;
            display: flex;
            gap: 15px;
            justify-content: flex-end;
            &>img{
              width: 30px;
              height: 30px;
              cursor: pointer;
            }
            .m_b_ma_b_r_stop {
              width: 30px;
              height: 30px;
              border-radius: 14px;
              background: rgb(200 198 198);
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              & > span {
                width: 12px;
                height: 12px;
                background: rgb(124 124 124);
              }
            }
            &>span{
              display: flex;
              width: 30px;
              height: 30px;
              box-sizing: border-box;
              border: solid 1px #EBEEF5;
              border-radius: 50%;
              color: #000;
              font-weight: bold;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
